import _toConsumableArray from "/home/runner/work/spa/spa/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";
import Mail from '@spa/shared/svg/mail';
import Time from '@spa/shared/svg/time';
import Users from '@spa/shared/svg/users';
import { formatDate } from '@spa/shared/utils';
import Gender from '@spa/shared/svg/mixed-gender';
import FemaleGender from '@spa/shared/svg/female-gender';
import MaleGender from '@spa/shared/svg/male-gender';
import Registered from '@spa/shared/svg/registered';
import { GENDERS } from '@spa/shared/constants/genders';
import SharedBedroom from '@spa/shared/svg/shared-bedroom';
import { LANDLORD_OCCUPATION_TRANSLATIONS, LANDLORD_RESIDENT_AGE_RANGE_TRANSLATIONS } from '@spa/shared/constants/translations';
import LivesWithFamily from '@spa/shared/svg/lives-with-family';
import Pet from '@spa/shared/svg/pet';
import Professional from '@spa/shared/svg/professional';
import Student from '@spa/shared/svg/student';
import FemaleResidentLandlord from '@spa/shared/svg/female-resident-landlord';
import MaleResidentLandlord from '@spa/shared/svg/male-resident-landlord';
var DATE_FORMAT = 'MMM yyyy';
export var describeLivingWith = function describeLivingWith(_ref) {
  var _Object$values;
  var t = _ref.t,
    numberOfRoommates = _ref.numberOfRoommates,
    propertyGenderRestriction = _ref.propertyGenderRestriction,
    landlordResident = _ref.landlordResident;
  var roommates = numberOfRoommates ? [{
    translation: t("Up to {{count}} ".concat(numberOfRoommates > 2 ? 'roommates' : 'roommate'), {
      count: numberOfRoommates - 1
    }),
    icon: SharedBedroom
  }] : [];
  var gender = handleGenderRestrictions(t, propertyGenderRestriction, landlordResident === null || landlordResident === void 0 ? void 0 : landlordResident.gender);
  var landlord = [].concat(_toConsumableArray(landlordResident && Object.values(landlordResident).length && (_Object$values = Object.values(landlordResident)) !== null && _Object$values !== void 0 && _Object$values.every(function (key) {
    return key;
  }) ? [{
    translation: t('Resident landlord'),
    icon: landlordResident.gender === 'F' ? FemaleResidentLandlord : MaleResidentLandlord
  }] : []), _toConsumableArray((landlordResident === null || landlordResident === void 0 ? void 0 : landlordResident.family) === 'yes' ? [{
    translation: t('Landlord lives with family'),
    icon: LivesWithFamily
  }] : []), _toConsumableArray((landlordResident === null || landlordResident === void 0 ? void 0 : landlordResident.pets) === 'yes' ? [{
    translation: t('Landlord has pets'),
    icon: Pet
  }] : []));
  return [].concat(roommates, _toConsumableArray(gender), _toConsumableArray(landlord));
};
export var describeLandlordStats = function describeLandlordStats(_ref2) {
  var t = _ref2.t,
    language = _ref2.language,
    ageRange = _ref2.ageRange,
    family = _ref2.family,
    gender = _ref2.gender,
    pets = _ref2.pets,
    confirmedBookings = _ref2.confirmedBookings,
    responseRate = _ref2.responseRate,
    responseTime = _ref2.responseTime,
    createdAt = _ref2.createdAt,
    isRentByProperty = _ref2.isRentByProperty,
    occupation = _ref2.occupation;
  return [{
    icon: gender === 'F' ? FemaleResidentLandlord : MaleResidentLandlord,
    text: "".concat(t(GENDERS[gender])).concat(LANDLORD_RESIDENT_AGE_RANGE_TRANSLATIONS[ageRange] ? ", ".concat(LANDLORD_RESIDENT_AGE_RANGE_TRANSLATIONS[ageRange], " ").concat(t('years old')) : ''),
    condition: !!(gender && ageRange) && !isRentByProperty
  }, {
    icon: Pet,
    text: t('Has pets'),
    condition: pets === 'yes' && !isRentByProperty
  }, {
    icon: LivesWithFamily,
    text: t('Lives with family'),
    condition: family === 'yes' && !isRentByProperty
  }, {
    icon: occupation === 'professional-worker' ? Professional : Student,
    text: t(LANDLORD_OCCUPATION_TRANSLATIONS[occupation]),
    condition: !!occupation && occupation !== 'unknown' && !isRentByProperty
  }, {
    icon: Users,
    text: "".concat(t('Hosted'), " ").concat(confirmedBookings, " ").concat(confirmedBookings > 1 ? t('people') : t('person')),
    condition: confirmedBookings > 3
  }, {
    icon: Mail,
    text: "".concat(t('Response rate'), " ").concat(responseRate, "%"),
    condition: responseRate > 60
  }, {
    icon: Time,
    text: "".concat(t('Usually replies in'), " ").concat(Math.ceil(responseTime), " ").concat(Math.ceil(responseTime) > 1 ? t('hours') : t('hour')),
    condition: responseTime && responseTime < 24
  }, {
    icon: Registered,
    text: "".concat(t('Joined'), " ").concat(formatDate(new Date(createdAt), language, DATE_FORMAT)),
    condition: true
  }];
};
export var handleGenderRestrictions = function handleGenderRestrictions(t, genderRestriction, landlordResidentGender, offerLevel, isRentByProperty) {
  if (genderRestriction !== null && genderRestriction !== void 0 && genderRestriction.includes('males') && (landlordResidentGender !== 'M' || offerLevel)) {
    var offerGenderTranslation = isRentByProperty ? t('Females only') : t('Female only room');
    return [{
      translation: offerLevel ? offerGenderTranslation : t('Females'),
      icon: FemaleGender
    }];
  }
  if (genderRestriction !== null && genderRestriction !== void 0 && genderRestriction.includes('females') && (landlordResidentGender !== 'F' || offerLevel)) {
    var _offerGenderTranslation = isRentByProperty ? t('Males only') : t('Male only room');
    return [{
      translation: offerLevel ? _offerGenderTranslation : t('Males'),
      icon: MaleGender
    }];
  }
  return offerLevel ? [] : [{
    translation: t('Mixed gender'),
    icon: Gender
  }];
};